import React, { useMemo } from "react";
import { Scrollbar } from "react-scrollbars-custom";

import { Accordion, AccordionItemProps } from "../../../../components/accordion/accordion";
import { getBasketballToolPalette, getHockeyToolPalette, getSoccerToolPalette } from "../../../../config";
import { Sport, useGetUserPlaySettingsQuery } from "../../../../redux/slices";
import { getStencilById } from "../../../../utils";
import { usePlayContext } from "../../play-context";
import { CourtSettings } from "./court-settings/court-settings";
import styles from "./tool-pane.module.scss";

export const ToolPane = () => {
  const { selectItemApi, playStateApi, toolPaletteApi } = usePlayContext();

  const { selectedItems } = selectItemApi;
  const { activeFrame } = playStateApi;
  const { positionLabelType, togglePositionLabelType, changePositionLabelType } = toolPaletteApi;
  const { sport, labelType } = positionLabelType;

  const { data: userPlaySettings } = useGetUserPlaySettingsQuery();

  const toolPaletteItems = useMemo((): AccordionItemProps<any>[] => {
    switch (sport) {
      case Sport.BASKETBALL:
        return getBasketballToolPalette({ actionPaletteEnabled: userPlaySettings?.enbActPalette || false });
      case Sport.HOCKEY:
        return getHockeyToolPalette({ labelType, onChange: togglePositionLabelType });
      case Sport.SOCCER:
        return getSoccerToolPalette({ labelType, onChange: changePositionLabelType });
    }
  }, [sport, labelType, togglePositionLabelType, changePositionLabelType, userPlaySettings?.enbActPalette]);

  const stencil = getStencilById({
    stencils: activeFrame ? activeFrame.frameStencils : [],
    id: selectedItems[0] || "",
  }).stencil;

  return (
    <div className={styles.toolPaneNew}>
      <Scrollbar className={styles.courtMarkers}>
        <Accordion items={toolPaletteItems} />
      </Scrollbar>
      <Scrollbar className={styles.displayOptions}>
        <CourtSettings stencil={stencil} />
      </Scrollbar>
    </div>
  );
};
